import { request } from 'src/api/request';

export const getManagedUsers = async ({
  companyId,
  userId,
  queryParams,
}: {
  companyId: string;
  userId: string;
  queryParams: string;
}) => {
  return await request({
    url: `v1/accounts/companies/${companyId}/users/${userId}/managed_users/${queryParams}`,
    method: 'GET',
  });
};

export const bulkRoleAdd = async ({
  companyId,
  roleId,
  userIds,
}: {
  companyId: string;
  roleId: string;
  userIds: string[];
}) => {
  return await request({
    url: `v1/accounts/companies/${companyId}/roles/${roleId}/`,
    method: 'POST',
    data: {
      users: userIds,
    },
  });
};
